import { useState, useEffect } from 'react'
import CheckboxTree from 'react-checkbox-tree'
import 'react-checkbox-tree/lib/react-checkbox-tree.css'
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess'
import RuleFolderIcon from '@mui/icons-material/RuleFolder'
import ArticleIcon from '@mui/icons-material/Article'
import { IndeterminateCheckBox } from '@mui/icons-material'

export const TreeViewCheck = ({
  nodes,
  checked,
  setChecked,
  expanded,
  setExpanded,
  onlyOne = false,
  noCascade = true,
  restrictToLevel = false, // nuevo parámetro para activar la restricción por nivel
  activeHistorical = false 
}) => {
  const [levelByFamily, setLevelByFamily] = useState({});
  const [historicalChecked, setHistoricalChecked] = useState(checked ? [...checked] : [])
  const [aux, setAux] = useState(checked)

  const selectOnlyOne = (value) => {
    if (value.length === 1) {
      if (aux?.length === 0) {
        setAux(value)
      }
      if (Array.isArray(value)) {
        setChecked(value[0])
        return
      }
      setChecked(value)
    }
    else if (value.length >= 2) {
      let newVal = value.filter((item) => item !== aux)
      setChecked(newVal[0])
      setAux(newVal[0])
    }
    else {
      setChecked(null)
    }
  }

  const getDepth = (value, currentNodes, currentDepth = 0) => {
    for (let node of currentNodes) {
      if (node.value === value) {
        return currentDepth;
      }
      if (node.children) {
        const childDepth = getDepth(value, node.children, currentDepth + 1);
        if (childDepth !== -1) return childDepth;
      }
    }
    return -1; // -1 significa que no se encontró el nodo
  };

  const getDepthAndFamily = (value, currentNodes, currentDepth = 0, familyIndex = null) => {
    for (let i = 0; i < currentNodes.length; i++) {
      const node = currentNodes[i];
      // Si estamos en la raíz de una familia, actualizamos el familyIndex
      const currentFamilyIndex = currentDepth === 0 ? i : familyIndex;
      
      if (node.value === value) {
        return { depth: currentDepth, familyIndex: currentFamilyIndex };
      }
      if (node.children) {
        const result = getDepthAndFamily(value, node.children, currentDepth + 1, currentFamilyIndex);
        if (result !== null) return result;
      }
    }
    return null; // Retorna null si no se encuentra el nodo
  };


  const onCheck = (newChecked) => {
    if (onlyOne) {
      selectOnlyOne(newChecked);
      return;
    }
   
    let tempLevelByFamily = { ...levelByFamily };
  
    if (restrictToLevel && newChecked.length > 0) {
      newChecked.forEach((value) => {
        const { depth, familyIndex } = getDepthAndFamily(value, nodes);
        
        // Si es la primera selección para esta familia/grupo/nodo., actualiza el nivel registrado.
        if (tempLevelByFamily[familyIndex] === undefined) {
          tempLevelByFamily[familyIndex] = depth;
        }
      });

      // Filtrar las selecciones que no cumplen con el nivel registrado para su familia/grupo/nodo.
      newChecked = newChecked.filter((value) => {
        const { depth, familyIndex } = getDepthAndFamily(value, nodes);
        return tempLevelByFamily[familyIndex] === depth;
      });
    } else if (newChecked.length === 0) {
      tempLevelByFamily = {}; // Restablecer si todos los nodos se desmarcan
    }
  
    // Limpiar el registro para familias sin selecciones activas
    Object.keys(tempLevelByFamily).forEach(familyIndex => {
      const hasActiveSelection = newChecked.some(value => {
        const { familyIndex: checkFamilyIndex } = getDepthAndFamily(value, nodes);
        return familyIndex === checkFamilyIndex.toString(); // Asegurarse de que los tipos coincidan
      });
  
      if (!hasActiveSelection) {
        delete tempLevelByFamily[familyIndex];
      }
    });
    

    if (activeHistorical) {
      // Agregar todos los valores nuevos al historial
      const allHistoricalChecked = [...new Set([...historicalChecked, ...newChecked])];
      const updatedHistoricalChecked = allHistoricalChecked.filter(value => {
        // Verificar si el valor existe en los nodos actuales
        const exist = getDepthAndFamily(value, nodes)
        const isSelected = newChecked.includes(value);
        const condition = (exist !== null && isSelected) || (exist == null && !isSelected)
        return condition;
      });
      setHistoricalChecked(updatedHistoricalChecked);
      const allChecked = [...new Set([...updatedHistoricalChecked, ...newChecked])];
      setChecked(allChecked);
    } else {
      setChecked(newChecked);
    }
    setLevelByFamily(tempLevelByFamily);
  };
  
  const fontSize = { fontSize: '25px' }
  const icons = {
    check: <CheckBoxIcon style={fontSize} />,
    uncheck: <CheckBoxOutlineBlankIcon style={fontSize} />,
    halfCheck: <IndeterminateCheckBox style={fontSize} />,
    expandClose: <ExpandMoreIcon style={fontSize} />,
    expandOpen: <ExpandLessIcon style={fontSize} />,
    expandAll: <UnfoldMoreIcon style={fontSize} />,
    collapseAll: <UnfoldLessIcon style={fontSize} />,
    parentClose: <RuleFolderIcon style={fontSize} />,
    parentOpen: <FolderOpenIcon style={fontSize} />,
    leaf: <ArticleIcon style={fontSize} />,
  };

  return (
    <div className='App'>
      <CheckboxTree
        nodes={nodes}
        checked={Array.isArray(checked) ? checked : [checked]}
        expanded={expanded}
        onCheck={onCheck}
        onExpand={(expanded) => setExpanded(expanded)}
        noCascade={noCascade}
        checkModel='all'
        icons={icons}
      />
    </div>
  );
};
